export const getCountryName = ( countryName, countryNameOtherLanguages, soLanguageCultureCode ) => { 
  // Handle edge cases for stringified JSON parsing
  
  // Edge case 1: null, undefined, or empty string
  if (!countryNameOtherLanguages) {
    return countryName;
  }
  
  let parsed = null;
  
  // Edge case 2: Already an object (not a string)
  if (typeof countryNameOtherLanguages === "object") {
    parsed = countryNameOtherLanguages;
  } 
  // Edge case 3: Is a string - attempt to parse
  else if (typeof countryNameOtherLanguages === "string") {
    // Edge case 3a: Empty string or whitespace only
    if (countryNameOtherLanguages.trim() === "") {
      return countryName;
    }
    
    try {
      // Edge case 3b: Invalid JSON string
      parsed = JSON.parse(countryNameOtherLanguages);
    } catch (error) {
      // Edge case 3c: JSON parsing failed - log and return default
      return countryName;
    }
  }
  
  // Edge case 4: Parsed object is null or not an object
  if (!parsed || typeof parsed !== "object") {
    return countryName;
  }
  
  // Edge case 5: Return translated name if available, otherwise default country name
  const response = parsed[soLanguageCultureCode] || countryName;
  return response;
};